import React from "react";
import { Link, useParams } from "react-router-dom";

import "bootstrap/dist/css/bootstrap-grid.min.css";
import { Container } from "./styles";

export const Confirmation = () => {
	let { type } = useParams();

	return (
		<Container>
			<section className='container-fluid'>
				<div className='row justify-content-lg-center'>
					<div className='col-12 col-lg-5'>
						<div className='content'>
							<header>
								<h1 className='title m-text-center'>
									{type === "merchant" && (
										<React.Fragment>
											<span className='text-primary'>
												Obrigado por cadastrar sua loja
											</span>
											<br />
											no nosso Programa Fidelidade!
										</React.Fragment>
									)}

									{type === "consumer" && (
										<React.Fragment>
											<span className='text-primary'>
												Cadastro realizado com sucesso.
											</span>
										</React.Fragment>
									)}

									{type === "consumer-legacy" && (
										<React.Fragment>
											<span className='text-primary'>
												Cadastro realizado com sucesso.
											</span>
										</React.Fragment>
									)}
								</h1>
								<p className='m-text-center'>
									Programa Fidelidade Gerioox
								</p>
							</header>

							<p className='m-text-center'>
								{type === "consumer" &&
									"Em breve você receberá um e-mail com a confirmação de seu cadastro e seu cupom de boas-vindas."}
								{type === "consumer-legacy" &&
									"Em breve você receberá um e-mail com a confirmação de seu cadastro."}
								{type === "merchant" &&
									"Em breve você receberá um e-mail com a confirmação de seu cadastro."}
							</p>
						</div>
					</div>
				</div>
			</section>

			<section className='about'>
				<div className='content'>
					<h2>Sobre Gerioox</h2>
					<Link to={`${process.env.PUBLIC_URL}/`}>Saiba mais</Link>
				</div>
			</section>
		</Container>
	);
};

export default Confirmation;
